var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-case-mob-comp"},_vm._l((_vm.caseImgs),function(item,index){return _c('img',{key:index,attrs:{"src":item}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }